import { buildTestIds } from "application";
import { ModalGeneral } from "components";
import { theme } from "ui";
import { PaymentMethods as Content } from "./PaymentMethods.component";
import { PaymentMethodsProps } from "./PaymentMethods.types";
import * as PaymentMethodsSub from "./subcomponents";

/**
 * @description PaymentMethods component is used to display the payment methods available on the product page. The  product price with discount, credit card price with the installment fees and the credit card flags accepted..
 * @param data - The payment methods data that contains the price, discount and installments
 * @param onClickBackButton - function to be called when the back button is clicked
 * @param isMobile - boolean value to check if the device is mobile
 * @param isOpen - boolean value to check if the modal is open
 * @example
 * Mobile:
 *
 * <PaymentMethods isMobile={isClientMobile} data={data} onClickBackButton={() => confirm("Você tem certeza?")} />
 *
 * Desktop:
 *
 * <PaymentMethods data={data} isOpen={shouldOpenPaymentMethods} />
 * @see https://ferreiracosta.atlassian.net/browse/ECOMDGT-13084
 */
export const PaymentMethods = ({
  data,
  onClickBackButton,
  onCloseModal,
  isMobile = false,
  isOpen = false,
}: PaymentMethodsProps) => {
  if (!isMobile) {
    return (
      <ModalGeneral
        title="Formas de pagamento"
        centeredTitle
        bodyContent={<Content data={data} />}
        isOpen={isOpen}
        ariaLabelForModal="payment-methods"
        closeButtonSize={24}
        hasTitleBorder={false}
        padding="1.35rem 2rem 2rem 2rem"
        maxWidth="588px"
        titleFontSize={theme.typography.fontSize.md.x1}
        shouldCloseOnOverlayClick
        fontWeight={theme.typography.fontWeight["500"]}
        containerGap="0"
        contentGap={theme.space.x5}
        onCloseModal={onCloseModal}
      />
    );
  }

  return (
    <PaymentMethodsSub.MobileContainer {...buildTestIds("payment-methods")}>
      <PaymentMethodsSub.BackButton
        {...buildTestIds("payment-methods-back-button")}
        onClick={onClickBackButton}
      >
        <PaymentMethodsSub.BackIcon
          color={theme.colors.neutral["315"]}
          width={theme.space.x4}
          height={theme.space.x4}
        />
        Formas de pagamento
      </PaymentMethodsSub.BackButton>
      <Content data={data} />
    </PaymentMethodsSub.MobileContainer>
  );
};

export type { PaymentMethodsProps };
